import React, { useEffect, useState } from "react";

import config from '../../../config'
import { UserTransactionTable } from "./UserTransactionTable";
import { useMemo } from "react";
import { formatDate } from "../../../Utils/formatDate";

const base_url=config.base_url
export default function UserTransactions({customer_id}){
    const [transactions, setTransactions] = useState()
    const [error, setError] = useState()
    const fetchTransactions = (customer_id)=>{
        fetch(base_url+'admin/billing/transactions',{
            method: 'POST',
            mode: 'cors',
            headers: {
                'Accept': 'application/json, text/plain, */*',
                'Content-type': 'application/x-www-form-urlencoded',
                'credentials':'include'
            },
            body: `user_id=${customer_id}`,
            credentials:'include'
          }).then(res=>{
            if(res.status!==200) throw new Error()
            else return res.json()
          }).then(res=>{
            setTransactions(res?.result?.data)
          }).catch(e=>{
            setError('Unable to fetch user_transactions')
          })
    }
    useEffect(()=>{
        fetchTransactions(customer_id)
    }, [customer_id])
    useEffect(()=>{
        console.log(transactions)
    }, [transactions])
    const columns = useMemo(()=>[
        {
            Header: "User ID",
            accessor: "user_id",
            disableSortBy: true,
            Cell:({row, value})=>{
              return (<span>{value}</span>)
            }
        },
        {
            Header: "Date",
            accessor: "date",
            disableSortBy: true,
            Cell:({row, value})=>{
              return (<span>{formatDate(value*1000).split(' ')[0]}</span>)
            }
        },
        {
          Header: "Time",
          disableSortBy: true,
          Cell:({row, value})=>{
            return (<span>{formatDate(row.values.date*1000).split(' ')[1]}</span>)
          }
        },
        {
          Header: "Reason",
          accessor: "reason",
          disableSortBy: true,
          Cell:({row, value})=>{
            return (<span>{value}</span>)
          }
        },
        {
          Header: "Amount Chaged",
          accessor: "amount",
          disableSortBy: true,
          Cell:({row, value})=>{
            return (<span>{value/100 +"$"}</span>)
          }
        },
        {
          Header: "Transaction Responsible",
          accessor: "responsible",
          disableSortBy: true,
          Cell:({row, value})=>{
            return (<span>{value}</span>)
          }
        },
        {
            Header: "Comment",
            accessor: "comment",
            disableSortBy: true,
            Cell:({row, value})=>{
              return (<span>{value}</span>)
            }
        },
        {
          Header: "Invoice",
          accessor: "invoice_number",
          disableSortBy: true,
          Cell:({row, value})=>{
            const invoice_link = transactions?.map(e=>{
              if (e.invoice_number===value) return e.invoice_link
              return null
            }).filter(e=>e!==undefined)

            const invoice_link_=invoice_link
            console.log(invoice_link_)
            return (<a href={invoice_link_} target={invoice_link_}><span>{value}</span></a>)
          }
        },
        {
          Header: "Status",
          accessor: "status",
          disableSortBy: true,
          Cell:({row, value})=>{
            return (<span>{value}</span>)
          }
        },
        {
          Header: "Sending Date",
          accessor: "sending_dates",
          disableSortBy: true,
          Cell:({row, value})=>{
            console.log(value)
            return (<span>{formatDate(value*1000)}</span>)
          }
        },
        {
            Header: "Email Address",
            accessor: "email",
            disableSortBy: true,
            Cell: ({row,value})=>{
              return (<span>{value}</span>)
            }
        }], [transactions]);
    return(
        <>
        {   transactions&&
            <UserTransactionTable columns={columns} data={transactions} />
        }
        {error&&
            <div>{error}</div>
        }
        </>
    )
}